import React, { useState } from 'react';

import { motion } from 'framer-motion';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import noData from '../../assets/images/no-data.png';
import Button from '../../components/button/Button.component';
import Spinner from '../../components/loader/Spinner.component';
import { portfolioProjects } from '../../constants/projects';
import { tags } from '../../constants/tags';
import { AppWrap, MotionWrap } from '../../wrapper';
import './Work.scss';

const Work = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  const [projects, setProjects] = useState(portfolioProjects);
  const [loading, setLoading] = useState(false);

  const handleFilterProject = (tag) => {
    setLoading(true);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(async () => {
      setAnimateCard([{ y: 0, opacity: 1 }]);
      if (tag === 'All') {
        setProjects(portfolioProjects);
        setLoading(false);
        return;
      }
      const filteredProjects = portfolioProjects
        .filter((pro) => pro.tag === tag)
        .sort((a, b) => {
          if (a.liveLink && !b.liveLink) {
            return -1;
          } else if (!a.liveLink && b.liveLink) {
            return 1;
          } else {
            return 0;
          }
        });
      setProjects(filteredProjects);
      setLoading(false);
    }, 500);
  };

  return (
    <>
      <h2 className='head-text'>
        My Creative <span>Portfolio</span> Section
      </h2>
      <div className='app__work-filter'>
        {tags.map((item, index) => (
          <Button
            text={item}
            key={index}
            onClick={() => {
              setActiveFilter(item);
              handleFilterProject(item);
            }}
            active={activeFilter === item}
          />
        ))}
      </div>
      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__work-portfolio'
      >
        {loading && (
          <div className='app__work-loader'>
            <Spinner />
          </div>
        )}
        {!loading &&
          (projects?.length > 0 && !loading ? (
            projects?.map((work) => (
              <div className='app__work-item app__flex' key={work._id}>
                <div className='app__work-img app__flex'>
                  <img src={work.cover} alt={work.title} />
                  <motion.div
                    whileHover={{ opacity: [0, 1] }}
                    transition={{
                      duration: 0.25,
                      ease: 'easeInOut',
                      staggerChildren: 0.5,
                    }}
                    className='app__work-hover app__flex'
                  >
                    {
                      work.liveLink && <a href={work.liveLink} target='_blank' rel='noreferrer'>
                        <motion.div
                          whileInView={{ scale: [0, 1] }}
                          whileHover={{ scale: [1, 0.9] }}
                          transition={{
                            duration: 0.25,
                          }}
                          className='app__flex'
                        >
                          <AiFillEye />
                        </motion.div>
                      </a>
                    }
                    {
                      work.githubLink && <a href={work.githubLink} target='_blank' rel='noreferrer'>
                        <motion.div
                          whileInView={{ scale: [0, 1] }}
                          whileHover={{ scale: [1, 0.9] }}
                          transition={{
                            duration: 0.25,
                          }}
                          className='app__flex'
                        >
                          <AiFillGithub />
                        </motion.div>
                      </a>
                    }
                  </motion.div>
                </div>

                <div className='app__work-content app__flex'>
                  <h4 className='bold-text' style={{ textAlign: 'center' }}>{work.title}</h4>
                  <p className='p-text' style={{ marginTop: '10px', textAlign: 'center' }}>
                    {work.description}
                  </p>
                  <div className='app__work-tag app__flex'>
                    <p className='p-text'>{work.tag}</p>
                  </div>
                  {
                    !work?.liveLink && <p className='p-text' style={{ marginTop: '10px', textAlign: 'center', color: '#31A8FF', fontWeight: 'bold', fontSize: '0.7rem' }}>
                      Demo Available
                    </p>
                  }
                </div>
              </div>
            ))
          ) : (
            <div
              className='app__work-loader'
              style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
            >
              <img
                src={noData}
                style={{ width: '100px', height: '100px', opacity: 0.4 }}
                alt='no-date'
              />
              <p style={{ opacity: 0.4 }}>Pending Projects</p>
            </div>
          ))}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, 'app__works'),
  'work',
  'app__primarybg'
);
